module.exports = __webpack_public_path__ + "img/twitter.e32ab34f.svg";